<div class="relative flex w-[600px] max-w-[calc(100dvw-2rem)] flex-col justify-center overflow-hidden rounded-xl px-10 pb-10 pt-4">
  <h3>{{ 'chat.feedback.title' | transloco }}</h3>

  <p class="mt-4 text-base leading-5 max-md:text-sm">
    {{ 'chat.feedback.subtitle' | transloco }}
  </p>
  <textarea
    class="mt-4 h-auto max-h-24 w-full resize-none rounded-md border border-stone-300 p-3 leading-5 focus-visible:outline-none"
    [placeholder]="'chat.feedback.placeholder' | transloco"
    [formControl]="feedbackControl"
    rows="3"></textarea>

  <div class="mt-8 flex justify-end gap-3">
    <p-button variant="outlined" severity="contrast" (onClick)="closeModal()">
      {{ 'global.noThanks' | transloco }}
    </p-button>

    <p-button (onClick)="sendFeedback()" [disabled]="!feedbackControl.valid">
      {{ 'chat.feedback.sendFeedback' | transloco }}
    </p-button>
  </div>
</div>
